import { ALPHANUMERIC_REGEX, EMAIL_REGEX } from '@/lib/constants/validations';
import type { Option } from '@/pages/Configuration/Upgrade/type';

export const optionsList: Option[] = [
  { label: 'Analyst', value: 'Analyst' },
  { label: 'Automation Architect', value: 'Automation Architect' },
  { label: 'CEO', value: 'CEO' },
  { label: 'CTO', value: 'CTO' },
  { label: 'Consultant', value: 'Consultant' },
  { label: 'Director', value: 'Director' },
  { label: 'DevOps Engineer', value: 'DevOps Engineer' },
  { label: 'Engineering Manager', value: 'Engineering Manager' },
  { label: 'Development Engineer', value: 'Development Engineer' },
  { label: 'Manager', value: 'Manager' },
  { label: 'QA Engineer', value: 'QA Engineer' },
  { label: 'QA Lead', value: 'QA Lead' },
  { label: 'Service Provider', value: 'Service Provider' },
  { label: 'Software Engineer', value: 'Software Engineer' },
  { label: 'VP', value: 'VP' },
  { label: 'Others', value: 'Others' },
];

export const TopicList: Option[] = [
  { label: 'License Upgradation', value: 'License Upgradation' },
  { label: 'Token Renewal', value: 'Token Renewal' },
];
export const updateFormErrors = {
  firstName: false,
  lastName: false,
  email: false,
  phoneNumber: false,
  organizationName: false,
  jobTitle: false,
  message: false,
  others: false,
};

export const UPGRADE_FORM_VALIDATION = {
  userName: {
    required: {
      value: true,
      message: 'Name is required',
    },
    minLength: {
      value: 3,
      message: 'Minimum 3 characters required',
    },
    maxLength: {
      value: 25,
      message: 'Maximum 25 characters allowed',
    },
    pattern: {
      value: ALPHANUMERIC_REGEX,
      message: 'Special Characters are not allowed ',
    },
  },
  email: {
    required: {
      value: true,
      message: 'Email is required',
    },
    pattern: {
      value: EMAIL_REGEX,
      message: 'Enter valid email Id',
    },
  },
  organizationName: {
    required: {
      value: true,
      message: 'Organization Name is required',
    },
    minLength: {
      value: 3,
      message: 'Minimum 3 characters required',
    },
    maxLength: {
      value: 60,
      message: 'Maximum 60 characters allowed',
    },
  },
  others: {
    required: {
      value: true,
      message: 'Please specify your job title',
    },
    minLength: {
      value: 2,
      message: 'Minimum 2 characters required',
    },
    maxLength: {
      value: 25,
      message: 'Maximum 25 characters allowed',
    },
  },
};
